module.exports = __webpack_public_path__ + "static/media/fehlmann.d5e05c36.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/supplier/Logos_Lieferanten/fehlmann.png
// module id = 450
// module chunks = 0